export default __webpack_public_path__ + "static/media/bords.26ae6d03.svg";